import {useCallback, useEffect, useRef, useState} from "react";
import {error_message, get_report_preview} from "../../../redux/reports";
import {PAGE_SIZE} from "./utils";

/** @module Pages/Reports/UseReport */

/**
 * Consulta el reporte cada vez que cambian los segmentadores, como el Power BI: espera 250 ms
 * sin cambios y descarta respuestas de consultas anteriores.
 * @param {string} token
 * @param {string} type - colaborador | centro_costo | calendario
 * @param {object} filters - Resultado de build_filters
 * @returns {{data: object, loading: boolean, error: string, loadMore: function}}
 */
const useReport = (token, type, filters) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const request = useRef(0);
    const key = JSON.stringify(filters);

    const fetchPage = useCallback(async (page, append) => {
        const id = ++request.current;
        setLoading(true);
        setError("");
        try {
            const result = await get_report_preview(token, {type, filters: JSON.parse(key), page, size: PAGE_SIZE});
            if (id !== request.current) return;
            setData((prev) => (append && prev ? {...result, rows: [...prev.rows, ...result.rows]} : result));
        } catch (e) {
            if (id !== request.current) return;
            setError(await error_message(e));
            if (!append) setData(null);
        } finally {
            if (id === request.current) setLoading(false);
        }
    }, [token, type, key]);

    useEffect(() => {
        if (!token) return undefined;
        const timer = setTimeout(() => fetchPage(1, false), 250);
        return () => clearTimeout(timer);
    }, [token, fetchPage]);

    const loadMore = () => {
        if (data && data.rows && data.rows.length < data.total) {
            fetchPage(data.page + 1, true);
        }
    };

    return {data, loading, error, loadMore};
};

export default useReport;
